module.exports = __webpack_public_path__ + "static/media/20190201_154514.34c8ca8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20190201_154514.jpg
// module id = 485
// module chunks = 0